<template>
  <div class='home'>
    <WorkshopTypeList
      v-show='listView'
      @newWorkshopType='onClickNewFromList'
      @editWorkshopType='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <WorkshopTypeForm
      v-show='formView'
      :workshopType='workshopType'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import WorkshopTypeList from '@/components/workshop-type/WorkshopTypeList.vue'
import WorkshopTypeForm from '@/components/workshop-type/WorkshopTypeForm.vue'

export default {
  name: 'Workshop_Type',
  components: {
    WorkshopTypeList,
    WorkshopTypeForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      workshopType: {
        id: null,
        name: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      console.log(value)
      this.workshopType = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.workshopType = {
        id: null,
        name: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.workshopType = {
        id: null,
        name: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {}
}
</script>
